import type { DeepPartial } from '@luna/utils-ts';

import type { Documents } from '../../types/Documents';

export const documentsATFeatureConfig: DeepPartial<Documents> = {
    documentsUrlConfig: 'securitiesTradingContract',
    filterMarketDataDocument: true,
    requestForTitleDocuments: true,
    tokenForDocuments: true,
};
